export const DATE_FORMAT = "yyyy-MM-dd";
export const DATETIME_FORMAT = "yyyy-MM-dd HH:mm";

export const FORMAT_DASH_HMS = "yyyy-MM-dd HH:mm:ss";
export const FORMAT_DASH_HM = "yyyy-MM-dd HH:mm";
export const FORMAT_DASH = "yyyy-MM-dd";

export const FORMAT_SLASH_HMS = "yyyy/MM/dd HH:mm:ss";
export const FORMAT_SLASH_HM = "yyyy/MM/dd HH:mm";
export const FORMAT_SLASH = "yyyy/MM/dd";

export const FORMAT_DOT_HMS = "yyyy.MM.dd HH:mm:ss";
export const FORMAT_DOT_HM = "yyyy.MM.dd HH:mm";
export const FORMAT_DOT = "yyyy.MM.dd";

export const DATE_PARSE_FORMATS_WITH_TIME = [
  FORMAT_DASH_HMS,
  FORMAT_DASH_HM,
  FORMAT_DASH,
  FORMAT_SLASH_HMS,
  FORMAT_SLASH_HM,
  FORMAT_SLASH,
  FORMAT_DOT_HMS,
  FORMAT_DOT_HM,
  FORMAT_DOT,
];

export const DATE_PARSE_FORMATS_WITHOUT_TIME = [
  FORMAT_DASH,
  FORMAT_SLASH,
  FORMAT_DOT,
];
